import { useT } from "../../lib/i18n";

export default function PTLanguageToggle({ compact = false }) {
  const { lang, setLang } = useT();
  const buttonClass = (active) =>
    `chip transition-colors ${compact ? "px-1.5" : "px-2"} ${active ? "text-[#0A0A0A]" : "text-[#A3A3A3] hover:text-[#F5F3F0]"}`;
  const activeStyle = { background: "var(--joh-accent)" };

  return (
    <div className="inline-flex items-center gap-0.5 border border-[#F5F3F0]/15 px-1 py-1" data-testid="pt-lang-toggle" aria-label="Taal kiezen / Choose language">
      <button type="button" onClick={() => setLang("nl")} className={buttonClass(lang === "nl")} style={lang === "nl" ? activeStyle : undefined} aria-pressed={lang === "nl"} data-testid="pt-lang-nl">NL</button>
      <span className="chip text-[#4A4A4A] px-0.5" aria-hidden="true">|</span>
      <button type="button" onClick={() => setLang("en")} className={buttonClass(lang === "en")} style={lang === "en" ? activeStyle : undefined} aria-pressed={lang === "en"} data-testid="pt-lang-en">EN</button>
    </div>
  );
}
